import { datadogRum } from '@datadog/browser-rum';
import type { Site } from '@datadog/browser-rum';

export class DatadogRum {
  private static initialized = false;

  static Initialize(
    applicationId: string,
    clientToken: string,
    site: string,
    service: string,
    env: string,
    sessionSampleRate: number,
    sessionReplaySampleRate: number,
  ): void {
    if (DatadogRum.initialized) return;
    datadogRum.init({
      applicationId,
      clientToken,
      site: site as Site,
      service,
      env,
      sessionSampleRate,
      sessionReplaySampleRate,
      trackUserInteractions: true,
      // Mask everything by default — camera/ID capture elements are also
      // explicitly hidden via data-dd-privacy so a future default change
      // can't silently start recording biometric data.
      defaultPrivacyLevel: 'mask',
    });
    DatadogRum.initialized = true;
  }
}
